export default __webpack_public_path__ + "static/flyer1-eb268dfedee8e3e5af2d1d8cb891b5d5.jpg";